import { IAccount } from './company-account';

export enum WarrantyPeriod {
    SixMonths,
    TWelveMonths,
}

export interface InvoiceOptions {
    billTo: string;
    shipTo: string;
    buyingGroup: boolean;
    shipToAccount: IAccount;
    defaultWarrantyPeriod: WarrantyPeriod;
    isDirty?: boolean;
}
